import { Suspense } from "react";
import { Spinner } from "reactstrap";
import CategoryGrid, { CategoryGridItem } from "../CategoryGrid";

const CategoryGridMenu = ({
  items,
  isShop,
  className
}: {
  items: CategoryGridItem[];
  isShop?: boolean;
  className?: string;
}) => {
  return (
    <div>
      <Suspense fallback={<Spinner />}>
        <CategoryGrid items={items} isShop={isShop} className={className} />
      </Suspense>
    </div>
  );
};

export default CategoryGridMenu;
